export type QuestionTypeCategory = 'input' | 'dropdown' | 'checkbox' | 'radio' | 'other';

/** Known qstTypKey values (picklist group 20) confirmed against real data. */
export const QUESTION_TYPE_KEY = {
  INPUT: 711,
  RADIO: 712,
} as const;

/**
 * Classifies a question type primarily by its qstTypKey (confirmed IDs above).
 * Falls back to matching the picklist label text for types whose IDs aren't
 * confirmed yet, since the picklist itself is backend-driven.
 */
export function classifyQuestionType(
  label: string | null | undefined,
  typeKey?: number | null,
): QuestionTypeCategory {
  if (typeKey === QUESTION_TYPE_KEY.INPUT) return 'input';
  if (typeKey === QUESTION_TYPE_KEY.RADIO) return 'radio';

  const text = (label || '').toLowerCase();

  if (text.includes('radio')) return 'radio';
  if (text.includes('checkbox') || text.includes('check box')) return 'checkbox';
  if (text.includes('dropdown') || text.includes('drop down') || text.includes('select')) return 'dropdown';
  if (text.includes('input') || text.includes('text')) return 'input';

  return 'other';
}
